import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { NavigationStart, Router } from "@angular/router";
let RequestStatusService = class RequestStatusService {
    router;
    countBusyRequests = 0;
    busyRequests;
    // private countBusyRequests =0;
    requestBusySubject = new BehaviorSubject(false);
    $requestBusy = this.requestBusySubject.asObservable();
    constructor(router) {
        this.router = router;
        this.busyRequests = new Set();
        this.clearRequestsOnRouteChange();
    }
    showBusySpinner(key) {
        this.countBusyRequests++;
        if (!this.busyRequests.has(key)) {
            this.busyRequests.add(key);
        }
        this.updateSomeRequestBusy();
    }
    removeBusySpinner(key) {
        this.countBusyRequests--;
        this.busyRequests.delete(key);
        this.updateSomeRequestBusy();
    }
    removeBusySpinnerCompletely() {
        this.countBusyRequests = 0;
        this.busyRequests.clear();
        this.updateSomeRequestBusy();
    }
    updateSomeRequestBusy() {
        this.requestBusySubject.next(this.busyRequests.size > 0);
    }
    clearRequestsOnRouteChange() {
        this.router.events.subscribe(change => {
            if (change instanceof NavigationStart) {
                let newUrl = change.url;
                const index = newUrl.indexOf("?");
                if (index >= 0) {
                    newUrl = newUrl.substring(0, index);
                }
                if (this.router.url !== newUrl) {
                    this.busyRequests = new Set();
                }
            }
        });
    }
    printBusyIndicators() {
        this.busyRequests.forEach(key => {
            console.log(key);
        });
    }
    static ctorParameters = () => [
        { type: Router }
    ];
};
RequestStatusService = __decorate([
    Injectable({
        providedIn: "root"
    })
], RequestStatusService);
export { RequestStatusService };
